import { Table } from 'antd'
import Title from 'antd/es/typography/Title'
import { FC, useMemo } from 'react'
import TableWrapper from '../../../../../../../components/table-wrapper/table-wrapper'
import { useGetRewindQueueEntriesQuery } from '../../../../../../../store/api/rewind-queue-entries-api'
import { Zones } from '../../../../../../../types/api/rewind-queue-entry'
import { DocumentId } from '../../../../../../../types/strapi/strapi'
import { getRewindQueueQuery } from '../../../../constants/query-params'
import CustomRow from '../../../../../flexo/components/machines-queues/components/custom-row'
import { columns } from './columns'

interface MachineWaitingQueueProps {
    machineDocId: DocumentId
}

const MachineWaitingQueue: FC<MachineWaitingQueueProps> = ({ machineDocId }) => {
    const queryParams = useMemo(
        () => getRewindQueueQuery(machineDocId, Zones.Waiting),
        [machineDocId]
    )
    const { data } = useGetRewindQueueEntriesQuery(queryParams)
    const dataSource = data?.data || []

    return (
        <>
            <Title style={{ marginTop: 0 }} level={4}>
                Ожидание
            </Title>
            <TableWrapper
                style={{ flex: 'auto', height: '100%', width: '100%' }}
                filtersSummaryHeight={0}
                tableHasNotPagination
            >
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey='id'
                    size='small'
                    components={{ body: { row: CustomRow } }}
                />
            </TableWrapper>
        </>
    )
}

export default MachineWaitingQueue
